<template>
    <a-select
        showSearch
        placeholder="Select a block"
        class="w-100 block-picker"
        v-model="selectedBlockId"
        @change="handleChange"
        @search="handleSearch"
        @select="handleSelect"
        :notFoundContent="'No blocks found'"
        size="large"
        :filter-option="false"
    >
        <a-select-option
            :value="result.id"
            v-for="(result, index) of getFilteredResult()"
            :key="result.id"
            class="block-picker-item"
        >
            <div class="row">
                <div class="col-sm-3 d-flex flex-column justify-content-center">
                    <span>
                        <BlockIconPreview style="font-size: 16px" :block-type="result.type" class="img" />
                    </span>
                </div>
                <div class="col-sm-9">
                    <span class="blockTypeText">{{ result.name || result.type }}</span>
                </div>
            </div>
        </a-select-option>
    </a-select>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../utils/log2";
import BlockIconPreview from "../common/BlockIconPreview";
import { BlockStyles } from "../../../chatbot";

const log = log2("BlockPicker");
export default {
    name: "BlockPicker",
    components: {
        BlockIconPreview,
    },
    props: {
        flattedDiagram: {
            type: Array,
            required: true,
            default: () => [],
        },
        value: {
            type: String,
            required: false,
            default: "",
        },
        isGotoStep: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            query: "",
            selectedBlockId: this.value,
            BlockStyles,
        };
    },
    methods: {
        handleChange(blockId) {
            log(`selected ${blockId}`);
            this.selectedBlockId = blockId;
            this.query = "";
        },
        handleSelect(blockId) {
            log(`handleSelect ${blockId}`);
            this.selectedBlockId = blockId;
        },
        handleSearch(search) {
            log(`handleSearch ${search}`);
            this.query = search;
        },
        getFilteredResult() {
            const q = (this.query || "").trim().toLowerCase();
            const result = this.flattedDiagram.filter((block) => {
                return (
                    _.isEmpty(q) || (block.name || "").toLowerCase().includes(q) || block.type.toLowerCase().includes(q)
                );
            });
            log("getFilteredResult", result);
            if (this.isGotoStep) return result.filter((block) => block.type !== "GO_TO_STEP");
            else return result;
        },
    },
    mounted() {},
    watch: {
        selectedBlockId(newValue) {
            this.$emit("input", newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.block-picker {
    width: 100%;
}

.block-picker-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;

    .material-icons {
        color: #59687b;
        font-size: 20px;
    }
}

.img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #06a9f3;
    margin-right: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    &[data-type="START_POINT"] {
        color: #fff;
        background-color: #566e8a !important;
    }

    &[data-type="DEFAULT_FALLBACK"] {
        color: #fff;
        background-color: #797b8c !important;
    }

    &[data-type="DEFAULT_TIMEOUT"] {
        color: #fff;
        background-color: #d2ba69 !important;
    }

    &[data-type="AI_FUNCTIONS"] {
        color: #fff;
        //gradient blue-teal-white
        background-color: linear-gradient(90deg, #00c6ff 0%, #0072ff 100%) !important;
    }

    &[data-type="TIMEOUT"] {
        color: #fff;
        background-color: #d2ba69 !important;
    }

    &[data-type="BOT_RESPONSE"] {
        color: #647283;
        background-color: #f5f5f5 !important;
    }

    &[data-type="FALLBACK"] {
        color: #ffffff;
        background-color: #797b8c !important;
    }

    &[data-type="FILTER"] {
        color: #fff;
        background-color: #686ad3 !important;
    }

    &[data-type="FLOW"] {
        color: #000;
        background-color: #b3d6ff !important;
    }

    &[data-type="ATTACHMENT_INPUT"] {
        color: #647283;
        background-color: #e7e4e4 !important;
    }

    &[data-type="USER_INPUT"] {
        color: #59687b;
        background-color: #c9d3de !important;
    }

    &[data-type="GO_TO_STEP"] {
        color: #000;
        background-color: #ffdc67 !important;
    }

    &[data-type="ADD_TO_SEGMENT"] {
        color: #22314a;
        background-color: #9ccb80 !important;
    }

    &[data-type="REMOVE_FROM_SEGMENT"] {
        color: #22314a;
        background-color: #f5f5f5 !important;
    }

    &[data-type="WEBHOOK"] {
        color: #fff;
        background-color: #40455b !important;
    }

    &[data-type="SET_ATTRIBUTE"] {
        color: #fff;
        background-color: #6e5b8c !important;
    }

    &[data-type="QUESTION"] {
        color: #000;
        background-color: #ffad5c !important;
    }

    &[data-type="CLOSE_CHAT"] {
        color: #000;
        background-color: #f5f5f5 !important;
    }

    &[data-type="CLOSE_CHAT"] {
        color: #ffffff;
        background-color: #ad6fe9 !important;
    }

    &[data-type="TRANSFER_CHAT"] {
        color: #000;
        background-color: #76e394 !important;
    }

    &[data-type="TAG_CHAT"] {
        color: #000;
        background-color: #eded67 !important;
    }

    &[data-type="REMOVE_TAG"] {
        color: #000;
        background-color: #eded67 !important;
    }

    &[data-type="SEND_TRANSCRIPT"] {
        color: #ffffff;
        background-color: #4959da !important;
    }

    &[data-type="SEND_SMS"] {
        color: #ffffff;
        background-color: #4959da !important;
    }

    &[data-type="SEND_MAIL"] {
        color: #ffffff;
        background-color: #ff7a1f !important;
    }

    &[data-type="SUPPRESSION_ADD"] {
        color: #ffffff;
        background-color: #9d2126 !important;
    }

    &[data-type="HOLIDAY_PLUS_GET_HOTELS"],
    &[data-type="HOLIDAY_PLUS_GET_ROOMS"] {
        color: #ffffff;
        background-color: #82d1b2 !important;
    }

    &[data-type="TABLE_CREATE_RECORD"],
    &[data-type="TABLE_DELETE_RECORD"],
    &[data-type="TABLE_UPDATE_RECORD"],
    &[data-type="TABLE_FIND_RECORD"],
    &[data-type="TABLE_FIND_RECORDS"],
    &[data-type="INSTAGRAM_COMMENT_REPLY"],
    &[data-type="INSTAGRAM_COMMENT_DELETE"],
    &[data-type="INSTAGRAM_COMMENT_SHOW"],
    &[data-type="INSTAGRAM_COMMENT_HIDE"],
    &[data-type="INSTAGRAM_COMMENT_REPLY_AS_PRIVATE"] {
        color: #ffffff;
        background: #833ab4 !important;
        background: linear-gradient(to right, #833ab4, #fd1d1d, #fcb045) !important;
    }

    &[data-type="SUPPRESSION_REMOVE"] {
        color: #ffffff;
        background-color: #9d2126 !important;
    }

    &[data-type="CREATE_EVENT"] {
        color: #ffffff;
        background-color: #033c7c !important;
    }

    &[data-type="CREATE_RESERVATION"] {
        color: #ffffff;
        background-color: #235603 !important;
    }

    &[data-type="RESERVATION_OPEN_URL"] {
        color: #ffffff;
        background-color: #235603 !important;
    }

    &[data-type="RESERVATION_SELECT_DAY"] {
        color: #ffffff;
        background-color: #235603 !important;
    }

    &[data-type="RESERVATION_SELECT_TIME"] {
        color: #ffffff;
        background-color: #235603 !important;
    }

    &[data-type="RESERVATION_EVENT_LIST"] {
        color: #ffffff;
        background-color: #235603 !important;
    }

    &[data-type="SUCCESS"] {
        color: #00c800;
        background-color: #fff !important;
    }

    &[data-type="FAILURE"] {
        color: #ff0000;
        background-color: #fff !important;
    }

    &[data-type="SEND_WP_BUSINESS_MESSAGE"] {
        color: #fff;
        background-color: #4ee82f !important;
    }
}
</style>
